import { useEffect, useState } from 'react';
import { ApiService } from '../API/AxiosInstance';
import MainLayout from '../components/MainLayout';
import './Dashboard.css';
import Chart from 'react-apexcharts';
import { Box, Accordion, AccordionSummary, AccordionDetails, Divider, useMediaQuery, useTheme, Stack, Typography, Button, IconButton, Paper, Grid, Menu, MenuItem, CircularProgress, Tooltip } from '@mui/material';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ReactComponent as PlusIcon } from '../img/transactions/despositIcon.svg';
import { ReactComponent as MinusIcon } from '../img/transactions/withdrawIcon.svg';
import { ReactComponent as DownArrow } from '../img/DownArrow.svg';
import { ReactComponent as DollarSymbolIcon } from '../img/DollarSymbol.svg';
import { ReactComponent as IdleCashToolTip } from '../img/idleCashToolTip.svg';
import { useColors } from '../Theme/ColorModeContext';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import Freecurrencyapi from '@everapi/freecurrencyapi-js';
import moment from 'moment/moment';
import { useAuth0 } from '@auth0/auth0-react';
import EmptyChart from './EmptyChart';
import './chart.css';
import { round } from "reliable-round";
import { changeRiskTypeName } from './Products/UpcomingEvents';
import { ShimmerSkeleton } from '../utils/SkimmerSkeleton';
import BouncingDotsLoader from '../utils/BouncingDotsLoader';
import { getToken } from "firebase/messaging";
import { messaging } from '../firebase';
import { captureException } from '@sentry/react';
import OnboardingStatusHook from './customhook/onboardingStatus';
import { useInitiateIdleCash } from '../redux/idlecash.api';
import { calculatePercentageAmount } from '../utils/validation';
import TooltipContent from '../components/ToolTipContent';
import { ReactComponent as PauseCircleIcon } from '../img/transactions/holdIcon.svg';
import { ReactComponent as ProjectIcon } from '../img/products/projectIcon.svg';
import { ReactComponent as MaturityIcon } from '../img/products/maturityIcon.svg';
import { ReactComponent as AprYieldIcon } from '../img/products/aprYieldIcon.svg';
import BottomLogo from '../img/bottomLogo.png';

const AccordianStyle = { boxShadow: 'none', margin: '0px !important', }
const AccordianSummaryStyle = {
  '.MuiAccordionSummary-content': {
    marginTop: ' 0px !important',
  },
  padding: '0px',
  ' .MuiAccordionSummary-expandIconWrapper': {
    position: 'absolute',
    top: '-35px',
    right: 0,
  },
}

const expandIconStyle = {
  width: '45px',
  height: '45px',
  padding: '0px',
  backgroundColor: 'white !important',
  boxShadow: "0 2px 1px -1px rgba(0,0,0,0.2) !important",
  display: { xs: 'block', sm: 'none' }
}

  export const getTransactionColor = (type,colors) => {
    const colorMap = {
      // Green
      'Bought': colors.secondary.main,
      'Dividend Received': colors.secondary.main,
      'Subscribed': colors.secondary.main,
      'Deposit': colors.secondary.main,
      'Cash Rebate': colors.secondary.main,

      // Red
      'Unsubscribed': colors.error.main,
      'Management Fee': colors.error.main,
      'Sold': colors.error.main,
      'Withdraw': colors.error.main,

      'On Hold': 'yellow',
    };
    return colorMap[type] ?? colors.error.main;
  };

export const getSymbol = (type) => {
  const obj = [{ type: "Dividend Received", value: true }, { type: "Deposit", value: true }, { type: "Cash Rebate", value: true },
  { type: "Bought", value: true }, { type: "Withdraw", value: false }, { type: "Management Fee", value: false }, { type: "Sold", value: false }
  ]
  const value = obj?.find(item => item?.type == type)?.value
  return value
}

export default function Dashboard() {
  const theme = useTheme();
  const colors = useColors()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isTabScreen = useMediaQuery('(max-width:1024px)');
  const [chartDatas, setChartData] = useState([])
  const [graphData, setGraphData] = useState({})
  const [metrics, setMetrics] = useState({ netInvestedValue: 0, percentProfitLoss: 0 })
  const [anchorEl, setAnchorEl] = useState(null);
  const [currency, setCurrency] = useState(localStorage.getItem('dasboard_currentCurrency') ? localStorage.getItem('dasboard_currentCurrency') : 'SGD');
  const [prices, setPrices] = useState([])
  const [newsDatas, setNewsDatas] = useState([]);
  const expandInitialState = { rewards: false, news: true, upcoming_events: true, transaction: true }
  const [expand, setExpand] = useState(expandInitialState)
  const [userId, setUserId] = useState(localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).sub_id : '')
  const [products, setProducts] = useState([])
  const [allProducts, setAllProducts] = useState([])
  const navigate = useNavigate()
  const [duration, setDuration] = useState('1 Year')
  const freecurrencyapi = new Freecurrencyapi('fca_live_vwfRDGk3Sez0uggsKls6UuhMjuhi3KRiaM3zBljh');
  const [currentUSDPrice, setCurrentUSDPrice] = useState(0)
  const [transactions, setTransactions] = useState([])
  const [totalAmount, setTotalAmount] = useState('')
  const [loading, setLoading] = useState(false)
  const [transactionProducts, setTransactionProducts] = useState([])
  const [totalAmountLoading, setTotalAmountLoading] = useState(false)
  const [idleCash, setIdleCash] = useState({ value: 0.00, isInitialized: false })
  const { user } = useAuth0();
  const { onboardingStatusText, error } = OnboardingStatusHook(`${process.env.REACT_APP_BASE_URL}users/${userId}/onboarding/status`);
  const { mutate: initiateIdleCash, error: idleCahError } = useInitiateIdleCash();
  const profitLoseAmount = calculatePercentageAmount(metrics.netInvestedValue, metrics.percentProfitLoss)
  const [capitalToolTipOpen, setCapitalToolTipOpen] = useState(false);
  const [idleCashToolTipOpen, setIdleCashToolTipOpen] = useState(false);

  const tooltipText = !onboardingStatusText
    ? "Please complete the onboarding to view your idle cash balance."
    : !idleCash.isInitialized
      ? "Idle cash initialization has not completed."
      : "This figure represents the current usable balance available to either buy products or make a withdrawal.";

  const tooltipTextTitle = !onboardingStatusText
    ? "Onboard today to unlock"
    : !idleCash.isInitialized
      ? "Available Idle Cash"
      : "Available Idle Cash";

  useEffect(() => {
    if (userId) getIdleCash()
      localStorage.setItem("disclaimer_popup",true)
  }, [userId])

  useEffect(() => {
    if (userId && onboardingStatusText && idleCash?.hasOwnProperty("isInitialized") && !idleCash.isInitialized) { //3 Onboarding status must be completed and If idle cash not created yeat
      initiateIdleCash(userId);
    }
  }, [onboardingStatusText, idleCash.isInitialized, userId]);

console.log("currency ",currency)

  const requestNotificationPermission = async () => {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey: "BBK4y-Oi00_8ZLxfl6kopqSs29E4iHVSEc0pKq2uSvAIPHMvc4lETbXYqOcYk2z7pAzECQfJYOwtXpCknPrE94k",
        // vapidKey: "BLKaQnhhhsCuJB9hPH6WrJgIOqs-G6HzchVXS3WAIMvQhcrYXGtzBf6g_8wIEZ2K45gTLgJ2OvOZiCQ85qM9hSw"  //production  key
      });
      // Send this token to your backend to store and use it for push notifications
      localStorage.setItem('fcm_token', token)
      const deviceId = localStorage.getItem('device_id');
      if (!deviceId) registerDeviceToken(token) //register device only if location id not available in localStorage
    } else if (permission === "denied") {
      console.log("Permission denied for notifications.");
    }
  };

  const registerDeviceToken = async (token) => {
    const reqObj = { userId: userId, token: token, platform: "web" }
    try {
      const response = await ApiService().post('notifications/devices', reqObj)
      if (response?.data?.id) {
        localStorage.setItem('device_id', response?.data?.id)
        setTimeout(() => {
          resubscribeAllUsersFcm(response?.data?.id)
        }, 3000)

      }
    } catch (error) {
      captureException(error)
    }
  }

  const resubscribeAllUsersFcm = async (deviceId) => {
    try {
       await ApiService().post(`notifications/devices/${deviceId}/users/${userId}/subscriptions/resubscribe`)
    } catch (error) {
      console.log("error ", error)
      captureException(error)
    }
  }

  const getIdleCash = async () => {
    try {
      const response = await ApiService().get(`users/${userId}/idle-cash`)
      setIdleCash(prev => ({ ...prev, value: response?.data?.idleCashPortfolio?.amount, isInitialized: true }))
    } catch (error) {
      console.log("error ", error)
      setIdleCash(prev => ({ ...prev, value: 0.00, isInitialized: false }))

    }
  }


  const getUSDCurrecyValue = () => {
    freecurrencyapi.latest({
      base_currency: 'SGD',
      currencies: 'USD'
    }).then(response => {
      if (response?.data) {
        setCurrentUSDPrice(response?.data?.USD)
        getPrices(response?.data?.USD)
      }
    }).catch(error => {
      return false
    })
  }

  useEffect(() => {
    if (userId) {
      requestNotificationPermission()
    }
  }, [userId])

  useEffect(() => {
    if (localStorage.getItem('dasboard_currentCurrency')) {
      localStorage.setItem('dasboard_currentCurrency', currency)
      if (localStorage.getItem('dasboard_currentCurrency') == "USD") {
        getUSDCurrecyValue()
      }
    } else {
      localStorage.setItem('dasboard_currentCurrency', 'SGD')
    }

  }, [currency])

  useEffect(() => {
    if (user?.sub_id) {
      localStorage.setItem('userData', JSON.stringify(user))
      setUserId(user?.sub_id);
    }
  }, [user]);

  const handleDuration = (value) => {
    console.log("click")
    setDuration(value)
  }

  const resetToFirstDayOfMonth = (data) => {
    return data.map((item) => {
      const newDate = dayjs(item.date).startOf('month').format('YYYY-MM-DD');
      return { ...item, date: newDate };
    });
  };

  const getLastDayOfMonthData = (data) => {
    return data.reduce((acc, current) => {
      const currentDate = new Date(current.date);
      const yearMonth = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}`;

      if (!acc[yearMonth] || new Date(acc[yearMonth].date) < currentDate) {
        acc[yearMonth] = current;
      }

      return acc;
    }, {});
  };



  const filterData = (data, range) => {
    const singleDateForMonth = Object.values(getLastDayOfMonthData(data))
    const updatedCharty = resetToFirstDayOfMonth(singleDateForMonth);
    if (updatedCharty?.length > 0) {
      const now = dayjs();
      const filtered = updatedCharty?.filter(({ date }) => {
        const dataDate = dayjs(date);

        if (range === '6 Months') {
          const sixMonthsAgo = now.subtract(6, 'month');
          return dataDate.isAfter(sixMonthsAgo);
        } else if (range === '1 Year') {
          const oneYearAgo = now.subtract(1, 'year');
          return dataDate.isAfter(oneYearAgo);
        }

        return false;
      });


      return filtered;
    } else {
      return []
    }
  };

  useEffect(() => {
    if (chartDatas?.length > 0) {
      if (currency == "SGD") {
        getPrices()
      } else {
        getUSDCurrecyValue()
      }
    }
    return () => {
      localStorage.removeItem('prices')
    }
  }, [chartDatas, duration]);

  const getPrices = (currentPrice) => {
    const filtered = filterData(chartDatas, duration);
    if (chartDatas?.length > 0) {
      let formattedData = filtered.map(item => ({
        x: item.date,
        y: currentPrice ? parseFloat(sgdToUsd(parseFloat(item.price), 0.76)) : parseFloat(item.price)
      }));
      if (formattedData?.length == 1) {
        let oneDate = formattedData[0]?.x
        let dates = dayjs(oneDate).subtract(1, 'month').format('YYYY-MM-DD')
        formattedData?.unshift({ x: dates, y: 0 })
      }
      setPrices(formattedData);
      localStorage.setItem('prices', JSON.stringify(formattedData))
    }
    setLoading(false)
  }

  const sgdToUsd = (sgdPrice, currentUSPrice) => {
    const usdPrice = sgdPrice * currentUSPrice
    return usdPrice ? parseFloat(usdPrice) : 0
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (value) => {
    if (value) {
      setCurrency(value);
    }
    if (value == 'USD') {
      getUSDCurrecyValue()

      localStorage.setItem('dasboard_currentCurrency', 'USD')
    } else if (value == "SGD") {
      localStorage.setItem('dasboard_currentCurrency', 'SGD')
      getPrices()
    }
    setAnchorEl(null);
  };

  useEffect(() => {
    setExpand(expandInitialState)
  }, [isSmallScreen])

  useEffect(() => {
    makeChart()
  }, [isMediumScreen])

  const calculateTotalAmount = (data) => {
    const increasedAmount = (parseFloat(data.metrics.percentProfitLoss) / 100) * parseFloat(data.metrics.netInvestedValue);
    const calculatedAmount = parseFloat(data.metrics.netInvestedValue) + increasedAmount;
    const finalAmount = formatWithTwoDecimalRounding(calculatedAmount)
    setTotalAmountLoading(false)
    setTotalAmount(parseFloat(finalAmount))

  }
  const getNewsDatas = async () => {
    try {
      const response = await ApiService().get('/news');
      if (response?.data?.news?.length > 0) {
        const limit = response?.data?.news?.length > 5 ? response.data.news.slice(0, 5) : response.data.news
        setNewsDatas(limit);
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      captureException(error)
    }
  };

  const getChartData = async () => {
    try {
      const response = await ApiService().get(`users/${userId}/timeseries`)
      if (response?.data) {
        if (response?.data?.data?.length > 0) {
          setChartData(response.data.data)
          setLoading(false)
        }
      }
    } catch (error) {
      setLoading(false)
      captureException(error)
    }
  };

  const getMetrics = async () => {
    setTotalAmountLoading(true)
    try {
      const response = await ApiService().get(`users/${userId}/portfolio-metrics?isActiveOnly=true`)
      if (response?.data) {
        calculateTotalAmount(response?.data)
        setMetrics({ netInvestedValue: response.data.metrics.netInvestedValue, percentProfitLoss: response.data.metrics.percentProfitLoss })
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      setTotalAmountLoading(false)
      captureException(error)
    }
  };

  const getProducts = async () => {
    try {
      const response = await ApiService().get('products?limit=50')
      if (response?.data?.products?.length > 0) {
        setProducts(response?.data?.products)
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      captureException(error)
    }
  }
  const getSubscribedProducts = async (userId) => {
    try {
      const response = await ApiService().get(`portfolios?userId=${userId}&limit=50`)
      if (response?.data?.portfolios?.length > 0) {
        setTransactionProducts(response.data.portfolios?.filter(item => item.isActive))
      }

    } catch (error) {
      setLoading(false)
      captureException(error)
    }
  }

  const getRecentTransactions = async () => {
    try {
      const response = await ApiService().get(`portfolios/transactions?userId=${userId}&limit=7&page=0`)
      if (response?.data?.portfolioTransactions?.length > 0) {
        setTransactions(response?.data?.portfolioTransactions?.filter(item => !item.isArchived))
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      captureException(error)
    }
  }

  const formatWithTwoDecimalRounding = (num) => {
    // return Math.round((num + Number.EPSILON) * 100) / 100
    return round(num, 2)
  };


  useEffect(() => {
    if (products?.length > 0) {
      const resultArray = products.reduce((acc, firstObj) => {
        const isSubscribed = transactionProducts?.some(secondObj => secondObj.productId === firstObj.id);
        if (isSubscribed) {
          acc.push({ ...firstObj, subscribed: true });
        }
        return acc;
      }, []);
      setAllProducts(resultArray?.filter(item => item.isActive));
      setLoading(false);
    }
  }, [products, transactionProducts]);

  useEffect(() => {
    setLoading(true)
    if (userId) {
      getNewsDatas(userId)
      getChartData(userId)
      getMetrics(userId)
      getProducts(userId)
      getRecentTransactions(userId)
      getSubscribedProducts(userId)
    }
  }, [userId]);

  const returnPrice = () => {
    if (prices?.length > 0) {
      return prices
    }
  }

  useEffect(() => {
    makeChart()
  }, [prices]);

  const makeChart = () => {
    if (prices?.length > 0) {
      const chartData = {
        options: {
          chart: {
            type: 'area',
            toolbar: {
              show: false,
            },
            zoom: {
              enabled: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          yaxis: {
            tickAmount: 4,
            labels: {
              style: {
                fontWeight: '600',
                colors: colors.text.disabled2,
              },
              formatter: function (value) {
                return '$ ' + Math.round(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
              },
            },
          },
          xaxis: {
            type: 'category',
            tickAmount: 3,
            labels: {
              format: 'MMM yy',
              formatter: function (value) {
                return dayjs(value).format('MMM YY');
              },
              style: {
                fontWeight: '600',
                colors: colors.text.disabled2,
                paddingLeft: '20px',
              },
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
            tooltip: {
              enabled: false
            }
          },
          colors: [colors.primary.main],
          fill: {
            type: 'gradient',
            colors: [colors.primary.main],
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 90, 100],
            },
          },
          stroke: {
            width: 2,
            curve: 'smooth',
          },
          tooltip: {
            enabled: true,
            custom: function ({ dataPointIndex }) {
              const localStoragePrices = localStorage.getItem('prices') ? JSON.parse(localStorage.getItem('prices')) : ""
              const dataPoint = localStoragePrices[dataPointIndex];
              const date = dayjs(dataPoint?.x).format('MMM YYYY');
              const price = `$ ${dataPoint?.y.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

              return `<div style="background-color: white; padding: 5px 15px 0px; border-radius: 20px; text-align: center">
                      <p style="font-weight:600;font-family:CeraPro;font-size:13px;letter-spacing:2%;color:${colors.text.primary};">${date}</p>
                      <p style="font-weight:600;font-family:CeraPro;font-size:13px;letter-spacing:2%;color:${colors.text.primary};">${price}</p>
                    </div>`;
            },
          },
        },
        series: [
          {
            data: returnPrice(),
          },
        ],
      };

      setGraphData(chartData);
    } else {
      setGraphData({});
    }
  }

  const getRiskRating = (tags, riskType) => {
    const tag = tags?.find(tag => tag.metrics && tag.metrics[0]?.riskRating);
    if (riskType) {
      const returnedLabel = changeRiskTypeName(tag?.metrics[0]?.riskRating)
      return returnedLabel || '';
    } else {
      return tag?.metrics[0]?.riskRating || '';
    }
  };

  const getProjectedReturns = (tags) => {
    const tag = tags?.find(tag => tag.metrics && tag.metrics[1]?.projectedReturns);
    return tag?.metrics[1]?.projectedReturns || '';
  };

  const getTagIconUrl = (tags) => {
    const tag = tags?.find(tag => tag.iconUrl);
    return tag?.iconUrl ? tag?.iconUrl : "https://assets.tradetogether.app/products/BitcoinAdvantage.svg";
  };

//   const testNativeNotification = async () => {
//   if (!("Notification" in window)) {
//     console.log("Notifications not supported");
//     return;
//   }

//   if (Notification.permission !== "granted") {
//     console.log("Permission not granted:", Notification.permission);
//     return;
//   }

//   const registration = await navigator.serviceWorker.ready;
//   console.log("SW ready, scope:", registration.scope);

// for(let i=0;i<5;i++) {
//     registration.showNotification("Test Notification", {
//     body: "If you see this, showNotification() works fine.",
//     icon: "/bottomLogo.png", // must actually exist at this path
//      tag: `test-${i}-${Date.now()}-${Math.random().toString(36).slice(2)}`,
//   })
//   .then(() => console.log("✅ showNotification resolved successfully"))
//   .catch((err) => console.error("❌ showNotification failed:", err));
// }
// };

  return (
    <MainLayout>
      <Grid
        container
        spacing={{ sm: 3, xs: 1 }}
        sx={{ display: 'flex', flexDirection: 'flex-wrap', justifyContent: 'center', minWidth: { sm: '350px', xs: '310px' }, }} >

        {/* Chart */}

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper sx={{
            borderRadius: '15px',
            height: { sm: '100%' },
            boxShadow: `0px 1px 5px 0px ${colors.border.card};`
          }}
          >
            <>
              <Box
                sx={{
                  p: {xs:1,sm:4},
                  display: 'flex',
                  flexWrap: 'wrap',
                  flexDirection: {
                    md: 'row',
                    xs: 'column',
                  },
                  rowGap: 2,
                  justifyContent: { xs: "center", md: 'space-between' },
                  borderRadius: '15px',
                  position: 'relative',
                  marginBottom: '30px',
                  '@media(max-width:990px)': {
                    flexDirection: "column"
                  }
                }}
              >
                <Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Stack spacing={1} direction='column' sx={{ display: "flex" }}>
                      <Typography variant='h2' sx={{color:colors.nav.labelColor, fontWeight:"550", fontSize:{xs:"23px", md:"26.43px", lg:"28.43px", textAlign:"left" }}}>Current Balance</Typography>
                      {/* <Typography variant='h1' sx={{ display: 'inline-block', color: colors.text.primary }} >  $&nbsp; </Typography> */}
                      {(!loading && !totalAmountLoading) ? 
                        <Box sx={{display:"flex",gap:{xs:0,md:2}, flexDirection: {xs:"column", md:"row"}}}>
                          <Typography sx={{ display: 'inline-block', fontSize: { xs: "28px", sm: "40px", md: "60px" }, lineHeight: "76px", letterSpacing: "5%", color: colors.text.primary, fontWeight: "700", textAlign: {xs:"center",md:"left"} }}>$&nbsp;{(totalAmount != '' || totalAmount == 0) ? currency == "USD" ? sgdToUsd(totalAmount, currentUSDPrice?.toFixed(3)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : totalAmount == 0 ? 0 : totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}</Typography>
                          {!loading ? <Stack direction='row' sx={{marginTop:"0 !important", alignItems:"center", justifyContent:"center"}}>
                            {metrics?.percentProfitLoss?.toString()?.includes('-') ? <ArrowDropDownIcon style={{ fontSize: '35px', color: colors.error.main, fontWeight: "550" }} />
                              : <ArrowDropUpIcon style={{ fontSize: '35px', color: colors.success.main, fontWeight: "550" }} />
                            }
                            <Typography variant='h5' sx={{ color: metrics?.percentProfitLoss?.toString()?.includes('-') ? colors.error.main : colors.success.main, fontWeight: "550" }} > {metrics?.percentProfitLoss ? formatWithTwoDecimalRounding(parseFloat(metrics?.percentProfitLoss)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0} %</Typography>

                          </Stack> : <BouncingDotsLoader sx={{ width: "10px", height: "10px" }} />}
                        </Box>                      
                        : <BouncingDotsLoader sx={{ width: "40px !important", height: "40px !important", pl: "40px !important", margin: '3px 12px !important' }} />
                      }
                    </Stack>

                  </Box>
                  <Box sx={{ maxWidth:"400px", display: "flex", backgroundColor: colors.background.cardDivBg, flexDirection: "column", p: 1, borderTopLeftRadius: "8px", borderTopRightRadius: "4px", borderBottomLeftRadius: "8px", borderBottomRightRadius: "8px", margin: {xs: "0 auto", lg:'0'}, }}>
                    <Box sx={{ display: "flex", gap: 2, justifyContent: "space-between", }}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                          sx={{
                            textAlign: { xs: 'center', md: 'start' },
                            // marginTop: { xs: '10px', sm: '10px' },
                            color: colors.text.primary, fontWeight: "500", fontSize: { xs: "12px", lg: "14px" }
                          }}
                        >
                          Base Capital (P&L):
                        </Typography>
                        <Tooltip
                          open={capitalToolTipOpen}
                          onOpen={() => setCapitalToolTipOpen(true)}
                          onClose={() => setCapitalToolTipOpen(false)}
                          disableTouchListener
                          title={<TooltipContent title={"Total Investment in Products"} description={"This figure represents the total capital you have allocated across all investment products within your portfolio."} />}
                          placement="right"
                          componentsProps={{
                            tooltip: {
                              sx: {
                                bgcolor: "white",
                                color: colors.text.secondary,
                                boxShadow: 1,
                                fontWeight: "400",
                                border: `1px solid ${colors.border.default}`,
                                borderRadius: "12px",
                                letterSpacing: "1%",
                                fontSize: "12px",
                              },
                            },
                          }}
                          titleColor={"red"}
                          descriptionColor="red"
                          PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: { offset: [40, -10] },
                              },
                            ],
                          }}
                        >
                          <Box
                            onClick={() => {
                              // Toggle only on touch devices
                              if (window.matchMedia("(hover: none)").matches) {
                                setCapitalToolTipOpen((prev) => !prev);
                              }
                            }}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              p: 1,
                            }}
                          >
                            <IdleCashToolTip style={{ cursor: "pointer", pointerEvents: "auto", }} />
                          </Box>
                        </Tooltip></Box>

                      {!loading ? <Typography
                        sx={{
                          textAlign: 'right',
                          marginTop: { xs: '10px', sm: '10px' },
                          color: colors.text.primary,
                          fontWeight: "500",
                          fontSize: { xs: "12px", lg: "14px" },
                        }}
                      >
                        $ {' '}
                        {metrics?.netInvestedValue
                          ? currency == "USD"
                            ? sgdToUsd(
                              parseFloat(metrics?.netInvestedValue),
                              currentUSDPrice?.toFixed(3)
                            )?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                            : parseFloat(metrics?.netInvestedValue).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : 0} {' '}
                        <>
                          (<span
                            style={{
                              color: metrics?.percentProfitLoss?.toString()?.includes('-') ? colors.error.main :  colors.success.main,
                              marginLeft: "4px",
                              fontWeight:"550"
                            }}>
                            {`${metrics?.percentProfitLoss?.toString()?.includes('-') ? "- " : "+ "}`} ${' '}
                            {profitLoseAmount
                              ? currency == "USD"
                                ? sgdToUsd(
                                  parseFloat(profitLoseAmount),
                                  currentUSDPrice?.toFixed(3)
                                )?.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                                : parseFloat(profitLoseAmount).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })
                              : 0}
                          </span>{' '}
                          )
                        </>
                      </Typography> :
                        <BouncingDotsLoader sx={{ width: "10px", height: "10px" }} />
                      }
                    </Box>
                    <Divider sx={{
                      border: 0,
                       borderBottom: {
                        xs: `0.5px solid ${colors.border.grey}`,
                        sm: `0.5px solid ${colors.border.grey}`,   // explicitly filled, not skipped
                        md: `0.5px solid ${colors.border.grey}`,
                        lg: `0.5px solid ${colors.border.grey}`,
                      },
                      backgroundColor:"transparent",
                      opacity: 1,
                      mt: 1
                    }} />
                    <Box sx={{ display: "flex", gap: 2, justifyContent: "space-between", alignItems: "center", mt: 1 }}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                          sx={{
                            textAlign: { xs: 'center', md: 'start' },
                            color: colors.text.primary, fontWeight: "500", fontSize: { xs: "12px", lg: "14px" }
                          }}
                        >
                          Idle cash:
                        </Typography>
                        <Tooltip
                          open={idleCashToolTipOpen}
                          onOpen={() => setIdleCashToolTipOpen(true)}
                          onClose={() => setIdleCashToolTipOpen(false)}
                          disableTouchListener
                          title={<TooltipContent title={tooltipTextTitle} description={tooltipText} />}
                          placement="right"
                          componentsProps={{
                            tooltip: {
                              sx: {
                                bgcolor: "white",
                                color: colors.text.secondary,
                                boxShadow: 1,
                                fontWeight: "400",
                                border: `1px solid ${colors.border.default}`,
                                borderRadius: "12px",
                                letterSpacing: "1%",
                                fontSize: "12px",
                              },
                            },
                          }}
                          PopperProps={{
                            modifiers: [
                              {
                                name: "offset",
                                options: { offset: [40, -10] },
                              },
                            ],
                          }}
                        >
                          <Box
                          onClick={() => {
                              // Toggle only on touch devices
                              if (window.matchMedia("(hover: none)").matches) {
                                setIdleCashToolTipOpen((prev) => !prev);
                              }
                            }}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              p: 1,
                            }}
                          >
                            <IdleCashToolTip style={{ cursor: "pointer", pointerEvents: "auto" }} />
                          </Box>
                        </Tooltip>
                      </Box>

                      {!loading ? <Typography
                        sx={{
                          textAlign: 'right',
                          color: colors.text.primary,  fontWeight: "500", fontSize: { xs: "12px", lg: "14px" },
                          fontWeight: "500"
                        }}
                      >
                        $ {idleCash?.isInitialized ? currency == "USD" ? sgdToUsd(parseFloat(idleCash?.value), currentUSDPrice?.toFixed(3))?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : parseFloat(idleCash?.value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00'}
                      </Typography> :
                        <BouncingDotsLoader sx={{ width: "10px", height: "10px" }} />
                      }
                    </Box>
                  </Box>

                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap:{xs:"0", md:"16px"} }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginTop: { xs: '18px', md: '0px' },
                      '@media(max-width:990px)': {
                        marginTop: "18px"
                      }
                    }}
                  >
                    <Stack
                      spacing={1}
                      direction='row'
                      alignItems='center'
                      justifyContent='center'
                      onClick={handleClick}
                      sx={{
                        boxShadow: '0 0 3px 0 rgba(0,0,0,0.1)',
                        width: '130px',
                        height: '50px',
                        borderRadius: '23px',
                        cursor: "pointer"
                      }}
                    >
                      <Box sx={{ backgroundColor: colors.background.successBadge, width: '32px', height: '32px', borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <DollarSymbolIcon />
                      </Box>
                      <Typography variant='h5'>{currency}</Typography>

                      <Box color={colors.text.tertiary} mb={0.4} sx={{ cursor: "pointer" }} >
                        <KeyboardArrowDownIcon />
                      </Box>

                    </Stack>

                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={() => handleClose()}
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                      PaperProps={{
                        sx: {
                          minWidth: 130,
                          borderRadius: '10px',
                          boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
                          mt: 0.5,
                          border: `0.5px solid ${colors.border.cardDiv}`,
                        },
                      }}
                      MenuListProps={{
                        disablePadding: true,
                        sx: {
                          '& .MuiMenuItem-root': {
                            minHeight: 32,
                            padding: '12px 20px',
                            fontSize: 14,
                            letterSpacing: "0.5px",
                            lineHeight:"14px",                            
                          },
                        },
                      }}
                    >
                      <MenuItem sx={{backgroundColor: currency === "SGD" ? colors.background.cardDivBg :  'transaparent'}} onClick={() => handleClose('SGD')}>SGD (default)</MenuItem>
                      <MenuItem sx={{backgroundColor: currency === "USD" ? colors.background.cardDivBg :  'transaparent'}} onClick={() => handleClose('USD')}>USD</MenuItem>
                    </Menu>
                  </Box>

          {chartDatas?.length > 0 && <>
            <Box
              component='span'
              sx={{
                display: { xs: 'inline-block', sm: 'none' },
                alignItems: 'flex-start',
                width: 'fit-content',
                alignSelf: 'flex-end',
                mt: 4,
              }}
            >
              <Stack
                direction='row'
                spacing={0.5}
                sx={{
                  alignSelf: 'center',
                  justifyContent: 'center',
                  backgroundColor: colors.background.paper,
                  boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
                  borderRadius: '25px',
                  padding: '4px',
                }}
              >
                <Button
                  onClick={() => handleDuration('6 Months')}
                  disableElevation
                  sx={{
                    minWidth: '70px',
                    padding: '4px 10px',
                    borderRadius: '20px',
                    textTransform: 'none',
                    fontSize: '13px',
                    fontWeight: duration === '6 Months' ? 600 : 500,
                    color: duration === '6 Months' ? colors.background.paper : colors.text.secondary,
                    backgroundColor: duration === '6 Months' ? colors.primary.main : 'transparent',
                    boxShadow: 'none',
                    '&:hover': {
                      backgroundColor: duration === '6 Months' ? colors.primary.main : 'transparent',
                    },
                  }}
                >
                  6 Months
                </Button>
                <Button
                  onClick={() => handleDuration('1 Year')}
                  disableElevation
                  sx={{
                    minWidth: '70px',
                    padding: '4px 10px',
                    borderRadius: '20px',
                    textTransform: 'none',
                    fontSize: '13px',
                    fontWeight: duration === '1 Year' ? 600 : 500,
                    color: duration === '1 Year' ? colors.background.paper : colors.text.secondary,
                    backgroundColor: duration === '1 Year' ? colors.primary.main : 'transparent',
                    boxShadow: 'none',
                    '&:hover': {
                      backgroundColor: duration === '1 Year' ? colors.primary.main : 'transparent',
                    },
                  position: 'relative',
                  zIndex: 10,
                  }}
                >
                  1 Year
                </Button>
              </Stack>
            </Box>
            <Box
              sx={{
                display: { xs: "none", sm: 'flex' },
                alignItems: 'flex-start',
                justifyContent: { xs: 'center' },
                marginTop: { xs: '19px', sm:"19px", md: '0px' },
              }}
            >
              <Stack
                direction='row'
                spacing={0.5}
                sx={{
                  alignSelf: "center",
                  justifyContent: "center",
                  backgroundColor: colors.background.paper,
                  boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
                  borderRadius: '30px',
                  padding: '5px',
                  paddingTop: { xs: '24px', sm:"5px", md: '5px' },
                }}
              >
                <Button
                  onClick={() => handleDuration('6 Months')}
                  disableElevation
                  sx={{
                    minWidth: "85px",
                    borderRadius: '25px',
                    textTransform: 'none',
                    fontWeight: duration == '6 Months' ? 600 : 500,
                    color: duration == '6 Months' ? colors.background.paper : colors.text.secondary,
                    backgroundColor: duration == '6 Months' ? colors.primary.main : 'transparent',
                    boxShadow: 'none',
                    '&:hover': {
                      backgroundColor: duration == '6 Months' ? colors.primary.main : 'transparent',
                    },
                  }}
                >
                  6 Months
                </Button>
                <Button
                  onClick={() => handleDuration('1 Year')}
                  disableElevation
                  sx={{
                    minWidth: "85px",
                    borderRadius: '25px',
                    textTransform: 'none',
                    fontWeight: duration == '1 Year' ? 600 : 500,
                    color: duration == '1 Year' ? colors.background.paper : colors.text.secondary,
                    backgroundColor: duration == '1 Year' ? colors.primary.main : 'transparent',
                    boxShadow: 'none',
                    '&:hover': {
                      backgroundColor: duration == '1 Year' ? colors.primary.main : 'transparent',
                    },
                  }}
                >
                  1 Year
                </Button>
              </Stack>
            </Box>
            </>}
                </Box>
                
              </Box>
              {!loading ? <Box
                sx={{
                  height: { lg: '400px', xs: '390px' },
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  padding: {
                    sm: '0 10px 10px 10px',
                    xs: '0 0px 10px 0px'
                  },

                }}
              >
                <Box component='div' width='100%' sx={{ padding: { xs: "32px 10px", sm: "32px" } }} className="apexcharts-xaxis-texts-g custom-xaxis-shift">
                  {graphData?.options?.chart ? <Chart options={graphData?.options} series={graphData?.series} type="area" width="100%" height='400px' /> :
                    <EmptyChart />
                  }

                </Box>

              </Box> : <Box sx={{ width: "100%", height: "400px", display: "flex", justifyContent: "center", alignItems: "center" }}><CircularProgress disableShrink /></Box>}
            </>
          </Paper>
        </Grid>

        {isTabScreen && <Grid item xs={12} md={6} lg={4} sx={{
          minWidth: { sm: '360px', xs: '310px' },
          '@media(max-width:1375px)': {
            minWidth: '50%'
          },
          '@media(max-width:1052px)': {
            minWidth: '100%'
          }
        }} >
          <Paper
            sx={{
              padding: '20px',
              borderRadius: '15px',
              marginTop: {
                sm: '0px',
                xs: '25px',
              },
              '.MuiPaper-root': {
                borderRadius: '15px'
              },
              height: { sm: '100%' },
              boxShadow: `0px 1px 5px 0px ${colors.border.card}`
            }}
          >
            <Accordion key={3} sx={AccordianStyle} defaultExpanded={true} expanded={expand?.upcoming_events}>
              <AccordionSummary sx={AccordianSummaryStyle}
                expandIcon={
                  <IconButton onClick={() => setExpand((prev) => ({ ...prev, upcoming_events: !prev?.upcoming_events }))}
                    sx={expandIconStyle}><DownArrow />
                  </IconButton>}
              >
                <Box mt={{ xs: 2, sm: 0 }}
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: expand?.upcoming_events ? 'row' : 'column', sm: 'row' },
                    justifyContent: 'space-between', alignItems: "center",
                    width: '100%',
                  }}
                >
                  <Typography sx={{ letterSpacing: '1px', fontWeight: '700',  fontSize:"18px", color: colors.text.primary }} > Products </Typography>
                  {expand?.upcoming_events ? <Button variant="text" onClick={() => navigate('/Products')}> <Typography variant='h5' color={colors.secondary.main}>View all</Typography></Button> :
                    <Typography variant='h5' pt={1.2} sx={{ color: 'Title_Text_color' }}>See all products</Typography>}
                </Box>
              </AccordionSummary >
              <AccordionDetails sx={{ padding: '0px', display: "flex", justifyContent: "center" }}>
                <Box sx={{ maxHeight: "526px", overflow: "hidden auto", '&::-webkit-scrollbar': { display: 'none' }, msOverflowStyle: 'none', scrollbarWidth: 'none', width: "fit-content",  padding: "10px"  }}>
                  {!loading ? (
                    allProducts?.length > 0 ? (allProducts?.map((item, index) => (
                      <Box key={item.id} sx={{ mb: 2, maxWidth: { xs: '400px', md: '430px' }, display: 'flex', flexDirection: 'column', gap: '14px', width: "100%", alignSelf: "center", backgroundColor: colors.background.paper, borderRadius: '21px', padding: { xs: '14px', md: '20px' }, boxShadow: `0px 1px 5px 0px ${colors.border.card}` }}>

                        {/* Icon + Title row */}
                        <Box sx={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
                          <Box
                            sx={{
                              width: { xs: '52px', md: '60px' },
                              height: { xs: '52px', md: '60px' },
                              borderRadius: '14px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box component="img" src={getTagIconUrl(item?.tags)} sx={{ width: '32px', height: '32px', scale:2, objectFit: 'contain' }} />
                          </Box>
                          <Typography variant="h4" color="primary" sx={{ fontWeight: '600 !important',  color: colors.primary.main, fontSize: '16px', lineHeight: '1.3' }}>
                            {item?.name}
                          </Typography>
                        </Box>

                        {/* Stats row - single bordered container with inline dividers */}
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'stretch',
                            gap: '8px',
                            padding: getProjectedReturns(item?.tags) ? "0 5px" : '0px'
                          }}
                        >
                          {getProjectedReturns(item?.tags) && (
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '6px',
                                flex: 1,
                                width: { xs: '93px', md: '93px' },
                                height: { xs: '63px', md: '63px' },
                                boxSizing: 'border-box',
                                border: `1px solid ${colors.border.card}`,
                                borderRadius: '8px',
                              }}
                            >
                              <Box sx={{ display: "flex", flexDirection: "column",gap:"1px", alignItems:"center" }}>
                                <Box sx={{display:"flex",justifyContent:"center"}}><ProjectIcon /></Box>
                                <Typography sx={{ fontSize: '11px', fontWeight: '500', color: colors.neutral.outlinedText, textAlign:"center" }}>
                                  {(item?.id == 6 || item?.id == 8) ? '' : 'Project'}
                                </Typography>                                
                                {(item?.id == 6 || item?.id == 8) ? (
                                  ""
                                ) : (

                                    <Typography sx={{ fontSize: '11px', fontWeight: '600', color: colors.neutral.info100 }}>
                                      {getProjectedReturns(item?.tags)}%
                                    </Typography>
                                )}
                              </Box>
                             
                            </Box>
                          )}

                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                              flex: 1,
                              width: { xs: '93px', md: '93px' },
                              height: { xs: '63px', md: '63px' },
                              boxSizing: 'border-box',
                              border: `1px solid ${colors.border.card}`,
                              borderRadius: '8px',
                            }}
                          >
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems:"center",gap:"1px" }}>
                              <Box sx={{ display: "flex", justifyContent: "center" }}><MaturityIcon /></Box>
                              <Typography sx={{ fontSize: '11px', fontWeight: '500', color: colors.neutral.outlinedText, textAlign: "center" }}>
                                Maturity
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: '11px',
                                  fontWeight: 600,
                                  color: colors.neutral.success100,
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                {item?.tenor > 100000 ? (
                                  <Typography
                                    component="span"
                                    sx={{
                                      fontSize: '18px', // Increase as needed
                                      fontWeight: 700,
                                      lineHeight: 1,
                                    }}
                                  >
                                    ∞
                                  </Typography>
                                ) : (
                                  `${item?.tenor} Months`
                                )}
                              </Typography>
                            </Box>
                          </Box>

                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                              flex: 1,
                              width: { xs: '93px', md: '93px' },
                              height: { xs: '63px', md: '63px' },
                              boxSizing: 'border-box',
                              border: `1px solid ${colors.border.card}`,
                              borderRadius: '8px',
                            }}
                          >
                            <Box sx={{ display: "flex", flexDirection: "column",alignItems:"center", gap:"1px" }}>
                              <Box sx={{ display: "flex", justifyContent: "center" }}><AprYieldIcon /></Box>
                              <Typography sx={{ fontSize: '11px', fontWeight: '500', color: colors.neutral.orange100 }}>
                                APR Yield
                              </Typography>

                                <Typography sx={{ fontSize: '11px', fontWeight: '600', color: colors.neutral.outlinedText }}>
                                  {item?.expectedYield}%
                                </Typography>
                            </Box>
                          </Box>
                        </Box>

                        {/* Description - bordered box */}
                        <Box
                          sx={{
                            border: `1px solid ${colors.border.card}`,
                            borderRadius: '12px',
                            padding: '12px 14px',
                            backgroundColor:colors.legacy.Bg_color
                          }}
                        >
                          <Typography
                            variant="h6"
                            color="Grey"
                            sx={{
                              fontSize: '13px',
                              WebkitBoxOrient: 'vertical',
                              WebkitLineClamp: 4,
                              display: '-webkit-box',
                              overflow: 'hidden',
                              color: colors.text.gray,
                              letterSpacing:"0.5px",                              
                            }}
                          >
                            {item?.description}
                          </Typography>
                        </Box>

                        {/* More Info - full width filled button */}
                        <Box
                          onClick={() => navigate(`Products/productDetails/${item.id}`)}
                          sx={{
                            mt: '4px',
                            width: '100%',
                            // backgroundColor: colors.primary.main,
                            border:`1px solid ${colors.primary.main}`,
                            borderRadius: '3.26px',
                            padding: '12px',
                            textAlign: 'center',
                            cursor: 'pointer',
                          }}
                        >
                          <Typography sx={{ fontSize: '14px', fontWeight: '600',color: colors.primary.main, letterSpacing: '5%' }}>
                            More Info
                          </Typography>
                        </Box>

                      </Box>
                    ))) : (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%"
                        }}>
                        <Typography
                          sx={{
                            textAlign: 'center',
                            mb: { xs: 2, lg: 0 },
                            color: colors.text.tertiary,
                            fontWeight: "500",
                            fontSize: { xs: "18px", lg: "18px" }
                          }}
                        >
                          No Subscribed Products
                        </Typography>
                      </Box>
                    )
                  ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', justifyContent: 'center', row: { xs: '20px' }, gap: 4, width: "100%" }}>
                      {[1, 2, 3, 4, 5, 6, 7, 8]?.map(() => (
                        <ShimmerSkeleton sx={{ width: { xs: "200px", md: "250px" }, height: { xs: "100px", md: "150px" } }} />
                      ))}
                    </Box>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          </Paper>
        </Grid>}

        {isTabScreen && <Grid item xs={12} md={6} lg={4}
          sx={{
            minWidth: { sm: '360px', xs: '310px' },
            '@media(max-width:1375px)': { minWidth: '50%' },
            '@media(max-width:1052px)': { minWidth: '100%' }
          }}
        >
          <Paper sx={{
            padding: '25px',
            borderRadius: '15px',
            marginTop: { sm: '0px', xs: '25px' },
            height: "100%",
            boxShadow:`0px 1px 5px 0px ${colors.border.card}`
          }}>
            <Accordion key={4} sx={AccordianStyle} defaultExpanded={true} expanded={expand?.transaction} style={{ height: "100%" }}>
              <AccordionSummary sx={AccordianSummaryStyle}
                expandIcon={
                  <IconButton onClick={() => setExpand((prev) => ({ ...prev, transaction: !prev?.transaction }))}
                    sx={expandIconStyle}><DownArrow />
                  </IconButton>}
              >
                <Box mt={{ xs: 2, sm: 0 }}
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: expand?.transaction ? 'row' : 'column', sm: 'row' },
                    justifyContent: 'space-between', alignItems: "center",
                    width: '100%'
                  }} >
                  <Typography sx={{ letterSpacing: '1px', fontWeight: "700", fontSize:"18px", color: colors.text.primary}}>Recent Transactions </Typography>
                  {expand?.transaction ?
                    <Button variant="text" onClick={() => navigate('/Transactions')}>
                      <Typography variant='h5' color={colors.secondary.main}>View all</Typography>
                    </Button> :
                    <Typography variant='h5' pt={1.2} sx={{ color: 'Title_Text_color' }}>See your recent transactions</Typography>}
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: '0px' }}>
                <Box rowGap={3.5}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    overflow: "auto hidden",
                    '&::-webkit-scrollbar': { display: 'none' },
                    msOverflowStyle: 'none',
                    scrollbarWidth: 'none',
                    height: '100%',
                    justifyContent: transactions?.length === 0 && !loading ? 'center' : 'flex-start', // Adjust content position
                    alignItems: transactions?.length === 0 && !loading ? 'center' : 'flex-start',  // Center if no transactions
                  }}
                >
                  {!loading ? (
                    transactions?.length > 0 ? (transactions?.map((itm) => {
                      return (
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: "100%",
                          }}
                        >
                          <Box columnGap={{ xs: 1, sm: 3 }}
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}
                          >
                            {getTransactionColor(itm.type,colors) === colors.secondary.main ? (
                              <PlusIcon />
                            ) : getTransactionColor(itm.type,colors) === 'yellow' ? (
                              <PauseCircleIcon sx={{ color: '#FFC107' }} />
                            ) : (
                              <MinusIcon />
                            )}
                            <Box>
                              <Typography variant='h5_1' >{moment.utc(itm.transferDate).local().format('DD MMM YYYY')} </Typography>
                            </Box>
                          </Box>
                          <Box mr={1}>
                            <Typography
                              variant='h5_1'
                              sx={{
                                color: getTransactionColor(itm.type,colors) === colors.secondary.main
                                  ? colors.secondary.main
                                  : getTransactionColor(itm.type,colors) === 'yellow'
                                    ? "#FFC107"
                                    : colors.error.main
                              }}
                            >
                              {getTransactionColor(itm.type,colors) === colors.secondary.main ? '+' : getTransactionColor(itm.type,colors) === 'yellow' ? '' : '-'} $ {itm?.amount ?
                                currency === "USD" ?
                                  sgdToUsd(parseFloat(itm?.amount), currentUSDPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) :
                                  parseFloat(itm?.amount)?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}
                            </Typography>
                          </Box>
                        </Box>
                      );
                    })) : (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%"
                        }}>
                        <Typography
                          sx={{
                            textAlign: 'center',
                            mb: { xs: 2, lg: 0 },
                            color: colors.text.tertiary,
                            fontWeight: "500",
                            fontSize: { xs: "18px", lg: "18px" }
                          }}
                        >
                          No Transactions
                        </Typography>
                      </Box>
                    )) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', justifyContent: 'center', row: { xs: '20px' }, gap: 4, width: "100%" }}>
                      {[1, 2, 3, 4, 5, 6, 7, 8]?.map(() => (
                        <ShimmerSkeleton sx={{ width: { xs: "200px", md: "250px" }, height: { xs: "100px", md: "40px" }, alignSelf: "center" }} />
                      ))}
                    </Box>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          </Paper>
        </Grid>}

        {/* NEWS */}

        <Grid item xs={12} md={6} lg={4} sx={{
          minWidth: { sm: '360px', xs: '310px' },
          '@media(max-width:1375px)': {
            minWidth: '50%'
          },
          '@media(max-width:1052px)': {
            minWidth: '100%'
          }
        }}   >
          <Paper
            sx={{
              padding: '20px',
              borderRadius: '15px',
              boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
              marginTop: {
                sm: '0px',
                xs: '25px',
              },
              height: { sm: '100%' },
            }}
          >
            <Accordion key={2} sx={AccordianStyle} defaultExpanded={true} expanded={expand?.news}>
              <AccordionSummary sx={AccordianSummaryStyle}
                expandIcon={
                  <IconButton onClick={() => setExpand((prev) => ({ ...prev, news: !prev?.news }))}
                    sx={expandIconStyle}><DownArrow />
                  </IconButton>}
              >
                <Box mt={{ xs: 2, sm: 0 }}
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: expand?.news ? 'row' : 'column', sm: 'row' },
                    justifyContent: 'space-between', alignItems: "center",
                    width: '100%',
                  }}
                >
                  <Typography sx={{ letterSpacing: '1px', fontWeight: "700", color: colors.text.primary, fontSize:"18px" }} > News</Typography>
                  {expand?.news ? <Button variant="text" onClick={() => navigate('/News')}> <Typography variant='h5' color={colors.secondary.main}>View all</Typography></Button> :
                    <Typography variant='h5' pt={1.2} sx={{ color: 'Title_Text_color' }}>See all your news</Typography>}
                </Box>
              </AccordionSummary >
              <AccordionDetails sx={{ padding: '0px' }}>
                <Box sx={{ maxHeight: "550px", overflowY: "scroll", overflowX: "hidden", '&::-webkit-scrollbar': { display: 'none' }, msOverflowStyle: 'none', scrollbarWidth: 'none', p:"5px" }}>
                  {!loading ? (newsDatas?.map((itm) => {
                    return (
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'flex-start',
                          width: '100%',
                          boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
                          marginBottom: '18px',
                          cursor: 'pointer',
                          padding: "10px 16px",
                          borderRadius: "12px"
                        }}
                        onClick={() => window.open(itm.news_url, '_blank')}
                      >
                        <Box
                          component={'img'}
                          sx={{
                            backgroundSize: 'cover',
                            borderRadius: '10px',
                            width: '65px',
                            height: '65px',
                            flexShrink: 0,
                          }}
                          src={itm?.image_url}
                        />
                        <Box sx={{ pl: 2, flex: 1, minWidth: 0 }}>
                          <Typography
                            sx={{
                              fontSize: '13px',
                              color: colors.text.gray,
                              marginBottom: '4px',
                              fontWeight: "500"
                            }}
                          >
                             {moment(itm?.published_at).fromNow()}
                          </Typography>

                          <Typography
                            variant='h6'
                            sx={{
                              fontWeight: '550',
                              fontSize: '15px',
                              letterSpacing: '2%',
                              color: colors.primary.main,
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                            }}
                          >
                            {itm?.title}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', justifyContent: 'center', row: { xs: '20px' }, gap: 4 }}>
                      {[1, 2, 3, 4, 5, 6, 7, 8]?.map(() => (
                        <ShimmerSkeleton sx={{ width: '100%', height: '40px' }} />
                      ))}
                    </Box>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          </Paper>
        </Grid>

        {/* upcoming Events */}

        {!isTabScreen && <Grid item xs={12} md={6} lg={4} sx={{
          minWidth: { sm: '360px', xs: '310px' },
          '@media(max-width:1375px)': {
            minWidth: '50%'
          },
          '@media(max-width:1052px)': {
            minWidth: '100%'
          }
        }} >
          <Paper
            sx={{
              padding: '20px',
              borderRadius: '15px',
              boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
              marginTop: {
                sm: '0px',
                xs: '25px',
              },
              '.MuiPaper-root': {
                borderRadius: '15px'
              },
              height: { sm: '100%' },
            }}
          >
            <Accordion key={3} sx={AccordianStyle} defaultExpanded={true} expanded={expand?.upcoming_events}>
              <AccordionSummary sx={AccordianSummaryStyle}
                expandIcon={
                  <IconButton onClick={() => setExpand((prev) => ({ ...prev, upcoming_events: !prev?.upcoming_events }))}
                    sx={expandIconStyle}><DownArrow />
                  </IconButton>}
              >
                <Box mt={{ xs: 2, sm: 0 }}
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: expand?.upcoming_events ? 'row' : 'column', sm: 'row' },
                    justifyContent: 'space-between', alignItems: "center",
                    width: '100%',
                  }}
                >
                  <Typography sx={{ letterSpacing: '1px', fontWeight: "700", fontSize:"18px", color: colors.text.primary }}> Products </Typography>
                  {expand?.upcoming_events ? <Button variant="text" onClick={() => navigate('/Products')}> <Typography variant='h5' color={colors.secondary.main}>View all</Typography></Button> :
                    <Typography variant='h5' pt={1.2} sx={{ color: 'Title_Text_color' }}>See all products</Typography>}
                </Box>
              </AccordionSummary >
              <AccordionDetails sx={{ padding: '0px', display: "flex", justifyContent: "center" }}>
                <Box sx={{ maxHeight: "526px", overflow: "hidden auto", '&::-webkit-scrollbar': { display: 'none' }, msOverflowStyle: 'none', scrollbarWidth: 'none', width: "fit-content", padding: "10px" }}>
                  {!loading ? (
                    allProducts?.length > 0 ? (allProducts?.map((item, index) => (
                      <Box key={item.id} sx={{ mb: 2, maxWidth: { xs: '400px', md: '430px' }, display: 'flex', flexDirection: 'column', gap: '14px', width: "100%", alignSelf: "center", backgroundColor: colors.background.paper, borderRadius: '21px', padding: { xs: '14px', md: '20px' }, boxShadow: `0px 1px 5px 0px ${colors.border.card}` }}>

                        {/* Icon + Title row */}
                        <Box sx={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
                          <Box
                            sx={{
                              width: { xs: '52px', md: '60px' },
                              height: { xs: '52px', md: '60px' },
                              borderRadius: '14px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0,
                            }}
                          >
                            <Box component="img" src={getTagIconUrl(item?.tags)} sx={{ width: '32px', height: '32px', scale:2, objectFit: 'contain' }} />
                          </Box>
                          <Typography variant="h4" color="primary" sx={{ fontWeight: '600 !important',  color: colors.primary.main, fontSize: '16px', lineHeight: '1.3' }}>
                            {item?.name}
                          </Typography>
                        </Box>

                        {/* Stats row - single bordered container with inline dividers */}
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'stretch',
                            gap: '8px',
                            padding: getProjectedReturns(item?.tags) ? "0 5px" : '0px'
                          }}
                        >
                          {getProjectedReturns(item?.tags) && (
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '6px',
                                flex: 1,
                                width: { xs: '93px', md: '93px' },
                                height: { xs: '63px', md: '63px' },
                                boxSizing: 'border-box',
                                border: `1px solid ${colors.border.card}`,
                                borderRadius: '8px',
                              }}
                            >
                              <Box sx={{ display: "flex", flexDirection: "column",gap:"1px", alignItems:"center" }}>
                                <Box sx={{display:"flex",justifyContent:"center"}}><ProjectIcon /></Box>
                                <Typography sx={{ fontSize: '11px', fontWeight: '500', color: colors.neutral.outlinedText, textAlign:"center" }}>
                                  {(item?.id == 6 || item?.id == 8) ? '' : 'Project'}
                                </Typography>                                
                                {(item?.id == 6 || item?.id == 8) ? (
                                  ""
                                ) : (

                                    <Typography sx={{ fontSize: '11px', fontWeight: '600', color: colors.neutral.info100 }}>
                                      {getProjectedReturns(item?.tags)}%
                                    </Typography>
                                )}
                              </Box>
                             
                            </Box>
                          )}

                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                              flex: 1,
                              width: { xs: '93px', md: '93px' },
                              height: { xs: '63px', md: '63px' },
                              boxSizing: 'border-box',
                              border: `1px solid ${colors.border.card}`,
                              borderRadius: '8px',
                            }}
                          >
                            <Box sx={{ display: "flex", flexDirection: "column", alignItems:"center",gap:"1px" }}>
                              <Box sx={{ display: "flex", justifyContent: "center" }}><MaturityIcon /></Box>
                              <Typography sx={{ fontSize: '11px', fontWeight: '500', color: colors.neutral.outlinedText, textAlign: "center" }}>
                                Maturity
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: '11px',
                                  fontWeight: 600,
                                  color: colors.neutral.success100,
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                {item?.tenor > 100000 ? (
                                  <Typography
                                    component="span"
                                    sx={{
                                      fontSize: '18px', // Increase as needed
                                      fontWeight: 700,
                                      lineHeight: 1,
                                    }}
                                  >
                                    ∞
                                  </Typography>
                                ) : (
                                  `${item?.tenor} Months`
                                )}
                              </Typography>
                            </Box>
                          </Box>

                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                              flex: 1,
                              width: { xs: '93px', md: '93px' },
                              height: { xs: '63px', md: '63px' },
                              boxSizing: 'border-box',
                              border: `1px solid ${colors.border.card}`,
                              borderRadius: '8px',
                            }}
                          >
                            <Box sx={{ display: "flex", flexDirection: "column",alignItems:"center", gap:"1px" }}>
                              <Box sx={{ display: "flex", justifyContent: "center" }}><AprYieldIcon /></Box>
                              <Typography sx={{ fontSize: '11px', fontWeight: '500', color: colors.neutral.outlinedText }}>
                                APR Yield
                              </Typography>

                                <Typography sx={{ fontSize: '11px', fontWeight: '600', color: colors.neutral.orange100  }}>
                                  {item?.expectedYield}%
                                </Typography>
                            </Box>
                          </Box>
                        </Box>

                        {/* Description - bordered box */}
                        <Box
                          sx={{
                            border: `1px solid ${colors.border.card}`,
                            borderRadius: '12px',
                            padding: '12px 14px',
                            backgroundColor:colors.legacy.Bg_color
                          }}
                        >
                          <Typography
                            variant="h6"
                            color="Grey"
                            sx={{
                              fontSize: '13px',
                              WebkitBoxOrient: 'vertical',
                              WebkitLineClamp: 4,
                              display: '-webkit-box',
                              overflow: 'hidden',
                              color: colors.text.gray,
                              letterSpacing:"0.5px",                          
                            }}
                          >
                            {item?.description}
                          </Typography>
                        </Box>

                        {/* More Info - full width filled button */}
                        <Box
                          onClick={() => navigate(`Products/productDetails/${item.id}`)}
                          sx={{
                            mt: '4px',
                            width: '100%',
                            border:`1px solid ${colors.primary.main}`,
                            color: colors.primary.main,
                            borderRadius: '3.26px',
                            padding: '12px',
                            textAlign: 'center',
                            cursor: 'pointer',
                          }}
                        >
                          <Typography sx={{ fontSize: '14px', fontWeight: '600', color: colors.primary.main, letterSpacing: '5%' }}>
                            More Info
                          </Typography>
                        </Box>

                      </Box>
                    ))) : (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%"
                        }}>
                        <Typography
                          sx={{
                            textAlign: 'center',
                            mb: { xs: 2, lg: 0 },
                            color: colors.text.tertiary,
                            fontWeight: "500",
                            fontSize: { xs: "18px", lg: "18px" }
                          }}
                        >
                          No Subscribed Products
                        </Typography>
                      </Box>
                    )
                  ) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', justifyContent: 'center', row: { xs: '20px' }, gap: 4, width: "100%" }}>
                      {[1, 2, 3, 4, 5, 6, 7, 8]?.map(() => (
                        <ShimmerSkeleton sx={{ width: { xs: "200px", md: "250px" }, height: { xs: "100px", md: "150px" } }} />
                      ))}
                    </Box>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          </Paper>
        </Grid>}

        {/* RECENT TRANSACTION */}

        {!isTabScreen && <Grid item xs={12} md={6} lg={4}
          sx={{
            minWidth: { sm: '360px', xs: '310px' },
            '@media(max-width:1375px)': { minWidth: '50%' },
            '@media(max-width:1052px)': { minWidth: '100%' }
          }}
        >
          <Paper sx={{
            padding: '25px',
            borderRadius: '15px',
            boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
            marginTop: { sm: '0px', xs: '25px' },
            height: "100%"
          }}>
            <Accordion key={4} sx={AccordianStyle} defaultExpanded={true} expanded={expand?.transaction} style={{ height: "100%" }}>
              <AccordionSummary sx={AccordianSummaryStyle}
                expandIcon={
                  <IconButton onClick={() => setExpand((prev) => ({ ...prev, transaction: !prev?.transaction }))}
                    sx={expandIconStyle}><DownArrow />
                  </IconButton>}
              >
                <Box mt={{ xs: 2, sm: 0 }}
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: expand?.transaction ? 'row' : 'column', sm: 'row' },
                    justifyContent: 'space-between', alignItems: "center",
                    width: '100%'
                  }} >
                  <Typography sx={{ letterSpacing: '1px', fontWeight: "700", fontSize:"18px", color: colors.text.primary }}>Recent Transactions </Typography>
                  {expand?.transaction ?
                    <Button variant="text" onClick={() => navigate('/Transactions')}>
                      <Typography variant='h5' color={colors.secondary.main}>View all</Typography>
                    </Button> :
                    <Typography variant='h5' pt={1.2} sx={{ color: 'Title_Text_color' }}>See your recent transactions</Typography>}
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: '0px' }}>
                <Box rowGap={3.5}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    overflow: "auto hidden",
                    '&::-webkit-scrollbar': { display: 'none' },
                    msOverflowStyle: 'none',
                    scrollbarWidth: 'none',
                    height: '100%',
                    justifyContent: transactions?.length === 0 && !loading ? 'center' : 'flex-start', // Adjust content position
                    alignItems: transactions?.length === 0 && !loading ? 'center' : 'flex-start',  // Center if no transactions
                  }}
                >
                  {!loading ? (
                    transactions?.length > 0 ? (transactions?.map((itm) => {
                      return (
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: "100%",
                          }}
                        >
                          <Box columnGap={{ xs: 1, sm: 3 }}
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}
                          >
                            {getTransactionColor(itm.type,colors) === colors.secondary.main ? (
                              <PlusIcon />
                            ) : getTransactionColor(itm.type,colors) === 'yellow' ? (
                              <PauseCircleIcon sx={{ color: '#FFC107' }} />
                            ) : (
                              <MinusIcon />
                            )}
                            <Box>
                              <Typography variant='h5_1' >{moment.utc(itm.transferDate).local().format('DD MMM YYYY')} </Typography>
                            </Box>
                          </Box>
                          <Box mr={1}>
                            <Typography
                              variant='h5_1'
                              sx={{
                                color: getTransactionColor(itm.type,colors) === colors.secondary.main
                                  ? colors.secondary.main
                                  : getTransactionColor(itm.type,colors) === 'yellow'
                                    ? "#FFC107"
                                    : colors.error.main
                              }}
                            >
                              {getTransactionColor(itm.type,colors) === colors.secondary.main ? '+' : getTransactionColor(itm.type,colors) === 'yellow' ? '' : '-'} $ {itm?.amount ?
                                currency === "USD" ?
                                  sgdToUsd(parseFloat(itm?.amount), currentUSDPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) :
                                  parseFloat(itm?.amount)?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}
                            </Typography>
                          </Box>
                        </Box>
                      );
                    })) : (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%"
                        }}>
                        <Typography
                          sx={{
                            textAlign: 'center',
                            mb: { xs: 2, lg: 0 },
                            color: colors.text.tertiary,
                            fontWeight: "500",
                            fontSize: { xs: "18px", lg: "18px" }
                          }}
                        >
                          No Transactions
                        </Typography>
                      </Box>
                    )) : (
                    <Box sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap', justifyContent: 'center', row: { xs: '20px' }, gap: 4, width: "100%" }}>
                      {[1, 2, 3, 4, 5, 6, 7, 8]?.map(() => (
                        <ShimmerSkeleton sx={{ width: { xs: "200px", md: "250px" }, height: { xs: "100px", md: "40px" }, alignSelf: "center" }} />
                      ))}
                    </Box>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          </Paper>
        </Grid>}

      </Grid>
    </MainLayout>
  );
}
